import React from 'react';
import { Switch } from 'react-router-dom';

import { PublicRoute } from 'app/shared/auth/public-route';
import PageNotFound from 'app/shared/error/page-not-found';
import { onBoard } from './pages/on-board/onBoard';
import Home from './pages/home/home';
import { Callback } from './pages/callback/callback';
// import TooLateStep from './modules/journey/ui/containers/steps/common/tooLate-step/tooLate-step';
// TODO: delete this page ?
// import { TooLatePage } from './pages/too-late/too-late-page';

const Routes = () => (
  <div className="view-routes">
    <Switch>

      {/* Obsolète */}
      <PublicRoute path="/onBoard/:secureToken/:subscriptionNumber" exact component={onBoard} />

      <PublicRoute path="/offre/:shortOfferCode?" exact component={Home} />
      <PublicRoute path="/subscribe" exact component={Home} />
      {/* <PublicRoute path="/too-late" exact component={TooLateStep} /> */}
      <PublicRoute path="/:subscriptionNumber/:callback" exact component={Callback} />
      <PublicRoute path="/:subscriptionNumber?" exact component={Home} />

      <PublicRoute component={PageNotFound} />

    </Switch>
  </div>
);

export default Routes;
